import type { RowData } from '@tanstack/react-table';

import type { ColumnType } from './table.types.ts';

/** Resolves a column accessor for TanStack Table (explicit fn, or key lookup). */
export const resolveColumnAccessorFn = <T extends RowData>(
  column: Pick<ColumnType<T>, 'accessorFn' | 'accessorKey'>
) =>
  column.accessorFn ??
  ((row: T) => (row as Record<string, unknown>)[column.accessorKey] as unknown);
